var React = require('react');

function IconArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.9678 1.35449L2.32261 11.9997L12.9678 22.6448","stroke":"white","strokeWidth":"2"}));
}

IconArrow.defaultProps = {"width":"14","height":"24","viewBox":"0 0 14 24","fill":"none"};

module.exports = IconArrow;

IconArrow.default = IconArrow;
